import { blocks } from '@yola/ws-sdk';

const matchWidgetElement = (element) =>
  element.matches(`[id^=${blocks.constants.WIDGET_ID_PREFIX}]`);

export default matchWidgetElement;
